import classNames from 'classnames/bind';
import styles from './BookIndex.module.css';

import { useAppSelector } from '../../../../hooks/useRedux';
import { useSlice } from '../../../../hooks/useSlice';

import IndexItem from './IndexItem';
import { Library, IndexItem as TIndexItem } from '../../../../types/library';
import { INDENT, CONTENT, PAGE, EDIT } from '../../../../constants';
import { isMobile } from '../../../../utils/util';
import { useGetPagesQuery } from '../../../../services/common';
import { useState } from 'react';
import { isOfType } from '../../../../utils/typeGuard';

export default function BookIndex() {
  const cx = classNames.bind(styles);
  const { selectSelectedId, selectSelectedItem } = useSlice();

  const selectedId = useAppSelector(selectSelectedId);
  const selectedItem = useAppSelector(selectSelectedItem);

  const { data: indexData, isLoading: isIndexDataLoading } = useGetPagesQuery(
    selectedId,
    { refetchOnMountOrArgChange: true }
  );

  const [indexList, setIndexList] = useState<TIndexItem[]>(
    isOfType(selectedItem, 'projectIndex')
      ? selectedItem.projectIndex.indexList
      : []
  );
  const [editedIdx, setEditedIdx] = useState(0);

  const changeIndexList = (list: TIndexItem[], idx?: number) => {
    setIndexList(list);
    setEditedIdx(idx ?? 0);
  };

  if (isIndexDataLoading) return null;

  const { start, max, min, mappingTable } = indexData;

  return (
    <>
      {!isMobile && (
        <ul className={cx('list_head')}>
          <li>{INDENT}</li>
          <li>{CONTENT}</li>
          <li>{PAGE}</li>
          <li>{EDIT}</li>
        </ul>
      )}
      <ul className={cx('list_body')}>
        {indexList.length ? (
          indexList.map(
            ({ indentYn, content, page }: TIndexItem, i: number) => (
              <IndexItem
                key={`${page}_${i}`}
                indentYn={indentYn}
                content={content}
                mappingTable={mappingTable}
                page={page as number}
                start={start}
                max={max}
                min={min}
                idx={i}
                onEdit={changeIndexList}
                focusedIdx={editedIdx}
              />
            )
          )
        ) : (
          <IndexItem
            mappingTable={mappingTable}
            page={''}
            start={start}
            max={max}
            min={min}
            onEdit={changeIndexList}
          />
        )}
      </ul>
    </>
  );
}
